/* ActiNovo · Hebammen Mama-Kit LP — aus custom_liquid ausgelagert
   (Shopify begrenzt die custom_liquid-Einstellung auf 50 KB; ausgelagert
   ist der Code zudem seitenuebergreifend cachebar). */
(function(){
  var CFG = {"event":"hebammen_kit_requested","tag":"hebamme-mama-kit","anchor":"testkits","qtyField":"Anzahl Kits","roleField":"Du arbeitest als","volumeField":"Wie viele Frauen betreust du etwa im Monat?"};
  var KEY = 'anlp_lf_' + CFG.event;
  var form = document.getElementById('anlp-lf-form');

  function val(n){ var el = form && form.querySelector('[name="contact['+n+']"]:checked, [name="contact['+n+']"]'); return el ? el.value : ''; }

  if (form) {
    // Zweistufig: erst die zwei Tap-Fragen (Qualifizierung), dann Kontakt/Adresse.
    // Die Qualifizierung steht damit VOR der Tipp-Arbeit — wer in Schritt 2
    // abspringt, ist trotzdem als Segment gezählt (Event lead_step1_complete).
    (function steps(){
      var s1 = form.querySelector('[data-lf-step="1"]');
      var s2 = form.querySelector('[data-lf-step="2"]');
      var next = form.querySelector('[data-lf-next]');
      var back = form.querySelector('[data-lf-back]');
      var ind  = form.querySelector('[data-lf-ind]');
      if (!s1 || !s2 || !next) return;

      function paint(step){
        var dots = ind ? ind.querySelectorAll('span') : [];
        if (dots.length === 2){
          dots[0].classList.toggle('is-on', true);
          dots[1].classList.toggle('is-on', step === 2);
        }
        var lbl = ind ? ind.querySelector('b') : null;
        if (lbl) lbl.textContent = step === 2
          ? 'Schritt 2 von 2 · Lieferadresse'
          : 'Schritt 1 von 2 · Deine Praxis';
      }

      next.addEventListener('click', function(){
        var fields = s1.querySelectorAll('select, input[type="radio"]');
        for (var i = 0; i < fields.length; i++){
          if (!fields[i].checkValidity()){ fields[i].reportValidity(); return; }
        }
        s1.hidden = true; s2.hidden = false; paint(2);
        var first = s2.querySelector('input, select');
        if (first) { try { first.focus({ preventScroll: true }); } catch(e){ first.focus(); } }
        var panel = form.closest ? form.closest('.anlp-lf-panel') : null;
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        try {
          var role = form.querySelector('[name="contact[Du arbeitest als]"]');
          var vol  = form.querySelector('[name="contact[Wie viele Frauen betreust du etwa im Monat?]"]');
          var qty  = form.querySelector('[name="contact[Anzahl Kits]"]:checked');
          var payload = {
            lead_segment: CFG.tag,
            lead_role: role ? role.value : '',
            lead_volume: vol ? vol.value : '',
            kit_quantity: qty ? qty.value : ''
          };
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: 'lead_step1_complete' }, payload));
          if (typeof window.gtag === 'function') window.gtag('event', 'lead_step1_complete', payload);
        } catch(e){}
      });

      if (back) back.addEventListener('click', function(){
        s2.hidden = true; s1.hidden = false; paint(1);
        var panel = form.closest ? form.closest('.anlp-lf-panel') : null;
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    })();

    // Where the visitor came from — the ad channel is the whole point of this page.
    try {
      var src = form.querySelector('[data-lf-source]');
      if (src) src.value = (location.search || '').replace(/^\?/, '').slice(0, 400) || (document.referrer || 'direkt');
    } catch(e){}

    form.addEventListener('submit', function(){
      try {
        // A readable summary in contact[body] — the notification mail renders
        // that field as the message, custom fields only as a trailing list.
        var lines = [];
        Array.prototype.forEach.call(form.querySelectorAll('[name^="contact["]'), function(el){
          if (el.type === 'hidden' || el.name === 'contact[body]') return;
          if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
          var k = el.name.slice(8, -1);
          if (el.value) lines.push(k + ': ' + el.value);
        });
        var sum = form.querySelector('[data-lf-summary]');
        if (sum && lines.length) sum.value = lines.join('\n');

        var consent = form.querySelector('[data-lf-consent]');
        sessionStorage.setItem(KEY, JSON.stringify({
          email: val('email'), name: val('name'),
          qty: val(CFG.qtyField), country: val('Land'),
          city: val('Ort'), zip: val('PLZ'),
          role: CFG.roleField ? val(CFG.roleField) : '',
          volume: CFG.volumeField ? val(CFG.volumeField) : '',
          at: new Date().toISOString().slice(0, 10),
          consent: consent ? !!consent.checked : false
        }));
      } catch(e){}
    });
  }

  // The success panel only exists once Shopify re-renders the page after the
  // post. offsetParent guards the standalone preview, where both branches of
  // the Liquid conditional are emitted and the success one is just hidden.
  var ok = document.querySelector('.anlp-lf-ok');
  var posted = (ok && ok.offsetParent !== null) || /[?&]contact_posted=true/.test(location.search);
  if (!posted) return;

  var host = document.getElementById(CFG.anchor);
  if (host) setTimeout(function(){ host.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120);

  try {
    var raw = sessionStorage.getItem(KEY);
    if (!raw) return;
    var d = JSON.parse(raw);
    sessionStorage.removeItem(KEY);
    if (!d || !d.email) return;

    // GA4 first — analytics carries no personal data and runs either way.
    // Without it the B2B funnel is invisible (see the lp-learnings note).
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: CFG.event, kit_quantity: d.qty || '', lead_segment: CFG.tag });
    if (typeof window.gtag === 'function') {
      window.gtag('event', CFG.event, { kit_quantity: d.qty || '', lead_segment: CFG.tag });
    }

    // Omnisend ONLY on an explicit opt-in. identifyContact from the snippet
    // creates the contact as *subscribed* — verified against the contacts the
    // longevity tool produced — so calling it for someone who left the box
    // unticked would sign them up to the newsletter without consent. Their
    // request still reaches the team by mail; it is fulfilled by hand instead.
    if (!d.consent) return;

    var parts = String(d.name || '').trim().split(/\s+/);
    var contact = { email: d.email, tags: [CFG.tag] };
    if (parts[0]) contact.firstName = parts[0];
    if (parts.length > 1) contact.lastName = parts.slice(1).join(' ');
    if (d.city) contact.city = d.city;
    if (d.zip) contact.postalCode = d.zip;
    if (d.country) contact.country = d.country;
    contact.customProperties = {
      kit_quantity: d.qty || '',
      kit_role: d.role || '',
      kit_volume: d.volume || '',
      kit_requested_at: d.at || ''
    };

    window.omnisend = window.omnisend || [];
    // ['trackEvent', name, {flat props}] — the shape ActiNovo's longevity
    // automation already triggers on (origin "api") and splits by property.
    omnisend.push(["identifyContact", contact]);
    omnisend.push(["trackEvent", CFG.event, {
      quantity: d.qty || "",
      country: d.country || "",
      city: d.city || "",
      postal_code: d.zip || "",
      role: d.role || "",
      segment: CFG.tag
    }]);
  } catch(e){}
})();

(function(){
  var host = document.getElementById('anlp-reviews');
  if (!host || host.dataset.done) return;
  var opts = {"store":"10d058-95.myshopify.com","widget":"polaris","options":{"types":"product_review","lang":"de","per_page":6,"enable_overall_stars":true,"header":{"enable_summary":true,"enable_ratings":true,"enable_rating_breakdown":true,"enable_percent_recommended":false,"enable_write_review":false,"enable_sub_header":true,"rating_decimal_places":1},"reviews":{"enable_reviewer_name":true,"enable_reviewer_address":true,"address_format":"city_country","enable_verified_badge":true,"enable_product_name":true,"enable_images":true,"enable_ratings":true,"enable_date":true}}};
  function boot(){
    if (typeof window.ReviewsWidget !== 'function') return;
    host.dataset.done = '1';
    new window.ReviewsWidget('#anlp-reviews', opts);
  }
  function load(){
    if (window.ReviewsWidget) return boot();
    if (!window.__anlpReviewsLoading) {
      window.__anlpReviewsLoading = true;
      var s = document.createElement('script');
      s.src = 'https://widget.reviews.io/polaris/build.js';
      s.async = true;
      s.onload = boot;
      document.head.appendChild(s);
    } else {
      var t = setInterval(function(){ if (window.ReviewsWidget) { clearInterval(t); boot(); } }, 250);
      setTimeout(function(){ clearInterval(t); }, 15000);
    }
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){
      if (es.some(function(e){ return e.isIntersecting; })) { io.disconnect(); load(); }
    }, { rootMargin: '400px' });
    io.observe(host);
  } else { load(); }
})();